import * as Yup from "yup";
import { countriesMap } from "../../../data/countries";
export const phoneRegex =
  /^(\+?\d{1,4}[\s-]?)?(\(?\d{2,4}\)?[\s-]?)?[\d\s-]{5,15}$/;

export const existingAddressSchema = Yup.object().when("isExistingAddress", {
  is: true,
  then: Yup.object()
    .required("existing address is required")
    .test(
      "is-not-empty",
      "Please select an existing address",
      (value) => value && Object.keys(value).length > 0
    ),
  otherwise: Yup.object().nullable(),
});

export const zipCodeSchema = Yup.string().when(
  ["isExistingAddress", "country"],
  {
    is: (isExistingAddress, country) =>
      !isExistingAddress &&
      (countriesMap[country.id]?.hasZip || countriesMap[country.id]?.hasPostal),
    then: Yup.string().required("ZIP / Postal code is required"),
    otherwise: Yup.string().notRequired(),
  }
);

export const countrySchema = Yup.object()
  .shape({
    id: Yup.string(),
    name: Yup.string(),
  })
  .test("country-filled", "Country is required", (value) => {
    return value && value.id && value.name;
  });

export const getSelectObjectSchema = (message) => {
  Yup.object()
    .shape({
      id: Yup.string(),
      name: Yup.string(),
    })
    .test("country-filled", message, (value) => {
      return value && value.id && value.name;
    });
};

export const stateSchema = Yup.object()
  .shape({
    id: Yup.string(),
    name: Yup.string(),
  })
  .test("state-filled", "State / Province is required", (value) => {
    return value && value.id && value.name;
  });

export const itemTypeSchema = Yup.object()
  .shape({
    id: Yup.string(),
    name: Yup.string(),
  })
  .test("type-filled", "Type is required", (value) => {
    return value && value.id && value.name;
  });

export const addressSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters")
    .max(100, "Name must be at most 100 characters"),
  address1: Yup.string().required("Address is required"),
  address2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: stateSchema,
  country: countrySchema,
  zip: Yup.string().required("ZIP / Postal code is required"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(phoneRegex, "Enter a valid phone number"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});

export const itemSchema = Yup.object().shape({
  isImperial: Yup.boolean(),
  type: itemTypeSchema.required("Item type is required"),
  length: Yup.string().when("type", {
    is: (type) => type && type.name === "Package",
    then: Yup.string().required("Length is required for packages"),
    otherwise: Yup.string(),
  }),
  width: Yup.string().when("type", {
    is: (type) => type && type.name === "Package",
    then: Yup.string().required("Width is required for packages"),
    otherwise: Yup.string(),
  }),
  height: Yup.string().when("type", {
    is: (type) => type && type.name === "Package",
    then: Yup.string().required("Height is required for packages"),
    otherwise: Yup.string(),
  }),
  weight: Yup.string().when("type", {
    is: (type) => type && type.name === "Package",
    then: Yup.string().required("Weight is required for packages"),
    otherwise: Yup.string(),
  }),
});
